<template>
    <div>
        <el-dialog :title="track.name+'赛道信息'" :visible.sync="dialogFormVisible"
                   :close-on-click-modal="false"
                   append-to-body class="dialogFormVisibleDialog">
            <div class="examine">
                <h2>赛道信息:</h2>
                <div class="examineList">
                    <p>赛道名称 :</p>
                    <p>{{ track.name }}</p>
                </div>
                <div class="examineList">
                    <p>赛道类别:</p>
                    <div class="examineList" v-show="track.typeList.length > 0">
                        <div style="position: relative;">
                            <div>
                                <div v-for="(item,index) in track.typeList"  :key="index" class="modelHeightRangeClass">
                                    <p>{{ item.worksType }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="examineList">
                    <p>投票占比 :</p>
                    <p>{{ track.voteRatio }}</p>
                </div>
                <div class="examineList">
                    <p>评委评分占比 :</p>
                    <p>{{ track.judgesAppraisalRatio }}</p>
                </div>
            </div>
            <div class="examine">
                <h2>奖项设置:</h2>
                <div class="examineList" v-show="track.awardList.length > 0">
                    <p>赛道规则 :</p>
                    <el-table
                        border
                        :data="track.awardList"
                        style="width: 100%">
                        <el-table-column
                            prop="awardName"
                            label="奖项名称">
                        </el-table-column>
                        <el-table-column
                            prop="awardNumber"
                            label="奖项人数">
                        </el-table-column>
                        <el-table-column
                            prop="awardContent"
                            label="奖品名称">
                        </el-table-column>
                        <el-table-column
                            prop="awardUrl"
                            label="奖项配图"
                            align="center">
                            <template slot-scope="scope">
                                <img class="successImgsUrl" :src="scope.row.awardUrl">
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="dialogFormVisible = false">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: "wayDetailsDialog",
    data() {
        return {
            dialogFormVisible:false,
            track:{
                name:"",
                voteRatio:"",
                judgesAppraisalRatio:"",
                updateIndex:"",
                typeList:[],
                awardList:[],
            },
        }
    },
    created(){

    },
    methods: {
        init(item){
            this.track = {
                name:"",
                voteRatio:"",
                judgesAppraisalRatio:"",
                typeList:[],
                awardList:[],
            }
            if(item!==undefined&&item!==null){
                this.track = item;
            }
            this.dialogFormVisible = true;
        },
    },
}
</script>

<style  scoped lang="less">
.examine {
    h2 {
        font-weight: 700;
        font-size: 16px;
        color: #000;
        margin-top: 26px;
        letter-spacing: 1px;
        border-top: 1px solid #efefef;
        padding-top: 16px;
    }
    &:nth-of-type(1) h2{
        border-top: none;
        padding-top: 0;
    }
    .examineList {
        display: flex;
        // align-items: center;
        img {
            width: 200px;
            height: 100px;
        }
        p:nth-of-type(1){
            margin-right: 16px;
            //width: 85px;
            flex-shrink: 0;
        }
        .examine_html {
            /deep/p {
                margin: 0;
            }
            /deep/img {
                max-width: 100%;
            }
        }
        .logoImg {
            display: flex;
            flex-wrap: wrap;
            img {
                margin-right: 10px;
                margin-bottom: 10px;
                width: 190px;
                height: 80px;
            }
        }
        margin-top: 2px;
    }
    .examineListTwo {
        display: flex;
        align-items: center;
        .examineListTwo_box {
            display: flex;
            align-items: center;
            width: 50%;
        }
    }

}
</style>



// WEBPACK FOOTER //
// src/views/activityManagement/activeDialog/wayDetailsDialog.vue